export function renderHero(): string {
  return `
    <section class="hero-section" id="mission">
      <div class="hero-content">
        <div class="badge">
          <span class="badge-pulse"></span>
          DEFENSE READINESS & TACTICAL INNOVATION
        </div>
        <h1 class="hero-title">
          Advancing Strategic Defense & <span class="gradient-text">Technological Superiority</span>
        </h1>
        <p class="hero-subtitle">
          Tribute Defense Solutions delivers resilient cybersecurity, autonomous defense systems, 
          and mission-critical software architectures engineered for high-stakes operational readiness.
        </p>
        <div class="hero-actions">
          <a href="#capabilities" class="btn-primary">Explore Capabilities</a>
          <a href="#contact" class="btn-secondary">Request Briefing</a>
        </div>
      </div>
    </section>
  `;
}

